import React from 'react';
import {
    ModalContentWrapper,
    ModalCloseButton,
    ModalTextContent,
    ModalTitle,
    ModalSubText,
    ModalButton,
} from './portfolios.styles';
import B2BNewClientModalBg from './assets/b2b-new-client-modal-bg.jpg';
import { BaseModal } from '../../../../common/components/BaseModal/BaseModal';
import { CloseIcon } from '../../../wealth/pages/asset/components/conformation/icons/icons';
import { useTrackEvent } from '../../../../hooks/useTrackEvent/useTrackEvent';
import { useStore } from '../../../app/data/root.store';

export const AddNewClientModal = ({ isOpen, onClose, onScheduleCallClick }) => {
    const { userStore } = useStore();
    useTrackEvent(
        'Popup Viewed',
        {
            tier: userStore.data?.profile?.tier,
            url: window.location.href,
            title: 'Schedule B2B Call',
        },
        [],
    );
    if (!isOpen) {
        return null;
    }

    return (
        <BaseModal width={'752px'} height={'auto'} customModalWrapperStyles={{ minHeight: '612px' }} borderRadius={8} onBackDropClick={onClose} noSidebarMargin>
            <ModalContentWrapper imageUrl={B2BNewClientModalBg}>
                <ModalCloseButton onClick={onClose}><CloseIcon /></ModalCloseButton>
                <ModalTextContent>
                    <ModalTitle>Turn this demo into your real dashboard.</ModalTitle>
                    <ModalSubText>Ready for the next step? Let's talk.</ModalSubText>
                    <ModalButton onClick={onScheduleCallClick}>
                        <CalendarIcon style={{ marginRight: '8px' }} />
                        Schedule a call
                    </ModalButton>
                </ModalTextContent>
            </ModalContentWrapper>
        </BaseModal>
    );
};

const CalendarIcon = () => {
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20 6H5V10.2467V18C5 18.5523 5.44772 19 6 19H19C19.5523 19 20 18.5523 20 18V6Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
            <line x1="5.5" y1="10.75" x2="20.5" y2="10.75" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
            <line x1="9.25" y1="8.04163" x2="9.25" y2="4.29163" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
            <line x1="15.5" y1="8.04163" x2="15.5" y2="4.29163" stroke="white" strokeWidth="1.5" strokeLinejoin="round" />
        </svg>
    );
};